import axios from 'axios'
//-----------------------------------果园列表
export function getPlantList (data) {
  return axios.get(`/manage/plantation/list`, { params: data })
}
//新增修改果园
export function modifyPlant (data, action) {
  return axios.post(`/manage/plantation/${action}`, data)
}
//获取果园详情
export function getPlantDetail (ids) {
  return axios.get(`/manage/plantation/${ids}`)
}
//获取果园详情
export function getPlantInfo (ids) {
  return axios.get(`/manage/getPlantationInfoById/${ids}`)
}
//获取果园村围区域
export function getVillagesOrFields (data) {
  return axios.get(`/system/region/pageList`, { params: data })
}
//搜索果园村围区域列表
export function getSelectPlantationArea () {
  return axios.get(`/manage/plantation/selectPlantationArea`)
}
//删除果园
export function delPlantation (ids) {
  return axios.delete(`/manage/plantation/${ids}`)
}

//判断果园是否可以派发走访
export function checkPlantationTask (data) {
  return axios.get(`/manage/plantation/queryLastAssignedVisitTaskTimeExpire`, { params: data })
}

//果园下拉列表
export function getDropPlantationList (data) {
  return axios.get(`/manage/plantation/queryDropDownBox`, { params: data })
}

//果园走访记录
export function getVisitTaskCropList (data) {
  return axios.get(`/manage/visitTaskCrop/list`, { params: data })
}

//---------------------------任务列表
export function getTaskList (data) {
  return axios.get(`/manage/visitTask/list`, { params: data })
}
//新增修改任务
export function modifyTask (data, action) {
  return axios.post(`/manage/visitTask/${action}`, data)
}
//获取任务详情
export function getTaskDetail (ids) {
  return axios.get(`/manage/visitTask/${ids}`)
}
//取消任务
export function modifyTaskStatus (data) {
  return axios.post(`/manage/visitTask/updateStatusById`, data)
}


//---------------------------历史变更列表
export function getAmdRecList (data) {
  return axios.get(`/manage/amdRec/list`, { params: data })
}

//---------------------------农残列表
export function getCropTestReportList (data) {
  return axios.get(`/manage/cropTestReport/list`, { params: data })
}
//新增修改农残
export function modifyCropTestReport (data, action) {
  return axios.post(`/manage/cropTestReport/${action}`, data)
}
//获取农残详情
export function getCropTestReportDetail (ids) {
  return axios.get(`/manage/cropTestReport/${ids}`)
}
//删除农残
export function delCropTestReport (ids) {
  return axios.delete(`/manage/cropTestReport/${ids}`)
}

//---------------------------采购计划列表
export function getPurchasePlanList (data) {
  return axios.get(`/manage/purchase-plan/list`, { params: data })
}
//新增
export function modifyPurchasePlan (data, action) {
  return axios.post(`/manage/purchase-plan/${action}`, data)
}
//获取
export function getPurchasePlanDetail (ids) {
  return axios.get(`/manage/purchase-plan/${ids}`)
}
//删除
export function delPurchasePlan (ids) {
  return axios.delete(`/manage/purchase-plan/${ids}`)
}


//---------------------------采摘批次列表
export function getPickBatchList (data) {
  return axios.get(`/manage/picking-batch/list`, { params: data })
}
//新增
export function addPickBatch (data) {
  return axios.post(`/manage/picking-batch/save`, data)
}
//新增
export function updatePickBatch (data) {
  return axios.post(`/manage/picking-batch/update`, data)
}
//批量修改
export function updatePickBatchList (data) {
  return axios.post(`/manage/picking-batch/updateBatch`, data)
}
//获取
export function getPickBatchDetail (ids) {
  return axios.get(`/manage/picking-batch/${ids}`)
}
//删除
export function delPickBatch (ids) {
  return axios.delete(`/manage/picking-batch/${ids}`)
}
//采摘修改批次选择果园列表
export function getPickManageList (data) {
  return axios.get(`/manage/crop/queryCropInfosOfPurchasePlan`, { params: data })
}
//采摘修改批次选择加工厂列表
export function getDropFactoryList (data) {
  return axios.get(`/manage/processFactory/pullDownList`, { params: data })
}
//新增修改任务
export function modifyPickingBatchTask (data) {
  return axios.post(`/manage/picking-batch-task/generatePickingBatchTask/`, data)
}
//获取
export function getPickingBatchTaskDetail (ids) {
  return axios.get(`/manage/picking-batch-task/${ids}`)
}

//基础配置
export function getSettingList (data) {
  return axios.get(`/manage/baseBusinessConfig/list`, { params: data })
}

//查询对应配置
export function getSettingByKey (data) {
  return axios.get(`/manage/baseBusinessConfig/queryInfoByCode`, { params: data })
}

//保存对应配置
export function saveSettingByKey (data) {
  return axios.post(`/manage/baseBusinessConfig/save`, data)
}